<template>
  <div id="detail-page" v-show="isShowArticle">
    <detail-page v-if="isValidArticle" :article="article"></detail-page>
    <detail-empty v-else></detail-empty>
    <div ref="articleFooter">
      <foot></foot>
    </div>
  </div>
</template>

<script>
import DetailEmpty from '~/components/detail-page/detail-empty.vue';
import DetailPage from '~/components/detail-page/index.vue';
import Foot from '~/components/common/foot.vue';
export default {
    components: {
        DetailEmpty,
        DetailPage,
        Foot
    },
    data() {
        return {
            isFootVisible: false,
            stayTime: 0,
            isShowArticle: false
        };
    },

    props: {
        article: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        isElementNotInViewport(el) {
            const rect = el.getBoundingClientRect();
            return (rect.top >= (window.innerHeight || document.documentElement.clientHeight) || rect.bottom <= 0);
        },

        handleScroll() {
            this.interval();
            this.$nextTick(() => {
                let timer;
                if (!this.isFootVisible) {
                    window.addEventListener('scroll', () => {
                        if (timer) {
                            clearTimeout(timer);
                        }
                        timer = setTimeout(() => {
                            if (!this.isFootVisible) {
                                this.setFootVisible();
                            }
                        }, 200);
                    });
                    this.setFootVisible();
                }
            });
        },

        setFootVisible() {
            if (this.isElementNotInViewport(this.$refs.articleFooter)) {
                return null;
            } else {
                this.isFootVisible = true;
            }
        },

        interval() {
            let second = 0;
            window.setInterval(() => {
                second++;
                this.stayTime = second;
            }, 1000);
        },
        collectDetailShow() {
            this.$collect.detailsShow(this.articleClass, this.article.id);
        },

        collectDetailEnd() {
            this.$collect.detailsEnd(
                this.isFootVisible ? 'yes' : 'no',
                this.stayTime,
                this.article.id,
                this.articleClass
            );
        }
    },
    computed: {
        articleClass() {
            switch (this.article.top_cate) {
                case 'wps':
                    return 'all';
                case 'xls':
                    return 'et';
                case 'doc':
                    return 'wps';
                case 'ppt':
                    return 'wpp';
                default:
                    return 'others';
            }
        },
        isValidArticle() {
            return this.article && Object.prototype.toString.call(this.article) === '[object Object]' && Object.keys(this.article).length > 0;
        }
    },

    head() {
        if (!this.isValidArticle) {
            return;
        }
        const header = this.$service.head.articleHead(this.article);
        return header;
    },

    mounted() {
        this.isShowArticle = true;
        this.collectDetailShow();
        this.handleScroll();
        window.addEventListener('beforeunload', (e) => this.collectDetailEnd(e));
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', (e) => this.collectDetailEnd(e));
    }
};
</script>

